export default __webpack_public_path__ + "static/media/3.a117c29b.jpg";